import { render } from "./UpdatePassword.vue?vue&type=template&id=68107667&scoped=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"

import "./UpdatePassword.vue?vue&type=style&index=0&id=68107667&lang=less&scoped=true"
import "./UpdatePassword.vue?vue&type=style&index=1&id=68107667&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68107667"]])

export default __exports__